import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
declare var $: any;
import { Router, ActivatedRoute } from '@angular/router';
import * as io from 'socket.io-client';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { KycService } from '../../services/kyc.service';
@Component({
  selector: 'app-kyc-header',
  templateUrl: './kyc-header.component.html'
}) 
export class KYCHeaderComponent implements OnInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};
  user: any;
  constructor(private _httpService: KycService,private modalService: NgbModal, private toastr: ToastrService, private router: Router) { }
  ngOnInit() {
    document.body.classList.remove('bg-img');
    // this.user = localStorage.getItem('KycUserName');
    const email = localStorage.getItem('userEmail');
    this.user =  email
    }
     
    onLogout() {
      this._httpService.logOut().subscribe(
        data => {
          console.log(data)
            } ,
        error => {
          console.log(error)
          },
        () => console.log('created employee', ));
      console.log('inside logout');
      // localStorage.setItem('buyertoken', null);
      // localStorage.setItem('currentUser', null);
      localStorage.removeItem('currentUser');
      localStorage.removeItem('customerID');
      localStorage.removeItem('role');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('KycUserName');
      this.router.navigate(['/login']);
    }
  }
